import { render } from "./Filters.vue?vue&type=template&id=80433af6&scoped=true"
import script from "./Filters.vue?vue&type=script&lang=js"
export * from "./Filters.vue?vue&type=script&lang=js"

import "./Filters.vue?vue&type=style&index=0&id=80433af6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80433af6"]])

export default __exports__